import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Divider, Grid } from '@mui/material'

import { Logger, LoggerTypes } from '../../utils'
import { attributesNames, userRightTypes, scenarioStatus } from '../../constants'
import {
  getProject,
  getScenarios,
  // getProjectVariables,
  // getProjectResources,
  // getProjectProducts,
  getProjectLocations,
  getProjectWeathers
  // getProjectParameters
} from '../../actions'
import { AccessControl, AccessControlNoRights, Page, PageCenter, PageLeft, PageNumSections } from '../../components' // PageRight,
import {
  // -- PROJECT
  ProjectCard,
  ProjectAttributesTabs,
  // -- SCENARIO
  // ScenarioConsole,
  ScenarioOfficialList,
  ScenarioOtherList,
  ScenarioArchivedList,
  ScenarioActionsBar
} from '../../containers'
import './style.scss'

let numLoaded = 0

export const Scenarios = () => {
  const projects = useSelector((state) => state.projects) || {}
  const scenarios = useSelector((state) => state.scenarios) || {}
  // -- Project's Attributes
  // const projectResources = useSelector((state) => state.projectResources) || {}
  // const projectProducts = useSelector((state) => state.projectProducts) || {}
  // const projectVariables = useSelector((state) => state.projectVariables) || {}
  const projectLocations = useSelector((state) => state.projectLocations) || {}
  const projectWeathers = useSelector((state) => state.projectWeathers) || {}
  // const projectParameters = useSelector((state) => state.projectParameters) || {}

  const [isLoading, setIsLoading] = useState(true)

  const { t } = useTranslation()
  const params = useParams()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  if (!scenarios) {
    return <></>
  }

  const { pid } = params

  const loadData = [
    { dispatch: getProject(pid), methodName: 'getProject' },
    { dispatch: getScenarios(pid), methodName: 'getScenarios' },
    { dispatch: getProjectLocations(pid), methodName: 'getProjectLocations', id: attributesNames.LOCATIONS },
    { dispatch: getProjectWeathers(pid), methodName: 'getProjectWeathers', id: attributesNames.WEATHER_DATA }
    // { dispatch: getProjectResources(pid), methodName: 'getProjectResources', , id: attributesNames.RESOURCES },
    // { dispatch: getProjectProducts(pid), methodName: 'getProjectProducts', , id: attributesNames.PRODUCTS },
    // { dispatch: getProjectVariables(pid), methodName: 'getProjectVariables', , id: attributesNames.VARIABLES },
    // { dispatch: getProjectParameters(pid), methodName: 'getProjectParameters', , id: attributesNames.PARAMETERS }
  ]

  useEffect(() => {
    loadData.forEach((_current) => {
      dispatch(_current.dispatch)
        .then((res) => {
          Logger.trace(LoggerTypes.CONTROLLER, `Scenarios.useEffect().dispatch(${_current.methodName}()).then()`, {
            _current,
            projects,
            scenarios,
            res
          })

          if (!res || !res.data || res.data.isAxiosError) {
            enqueueSnackbar(t('common.api_failure'), { variant: 'error' })
          }

          if (numLoaded === loadData.length - 1) {
            // enqueueSnackbar(t('common.api_success'), { variant: 'success' })
            setIsLoading(false)
          }
          numLoaded++
        })
        .catch((res) => {
          Logger.trace(LoggerTypes.WARN, `Scenarios.useEffect().dispatch(${_current.methodName}()).catch()`, {
            _current,
            projects,
            scenarios,
            res
          })
          const error = (res && res.response && res.response.data && JSON.stringify(res.response.data)) || ''
          enqueueSnackbar(`${t('common.api_failure')} ${error}`, { variant: 'error' })
        })
    })
  }, [])

  // -- PROJECT's items & attributes
  const currentProject = projects.currentProject || null
  const locationItems = (projectLocations && projectLocations.items) || []
  const weatherItems = (projectWeathers && projectWeathers.items) || []
  // const resourceItems = (projectResources && projectResources.items) || []
  // const productItems = (projectProducts && projectProducts.items) || []
  // const variableItems = (projectVariables && projectVariables.items) || []
  // const parameterItems = (projectParameters && projectParameters.items) || []

  // -- SCENARIO's lists
  const currentScenario = scenarios.currentScenario || null
  const scenarioItems = scenarios.items || []
  const officialScenarioItems = Object.values(scenarioItems).filter((row) => row.status === scenarioStatus.OFFICIAL)
  const otherScenarioItems = Object.values(scenarioItems).filter(
    (row) => row.status !== scenarioStatus.OFFICIAL && row.status !== scenarioStatus.ARCHIVED
  )
  const archivedScenarioItems = Object.values(scenarioItems).filter((row) => row.status === scenarioStatus.ARCHIVED)

  if (!isLoading) {
    Logger.trace(LoggerTypes.PAGE, 'Scenarios.render()', {
      numLoaded,
      loadData,
      projects: {
        projects,
        currentProject,
        attributes: {
          locationItems,
          weatherItems
          // resourceItems,
          // productItems,
          // variableItems,
          // parameterItems
        }
      },
      scenarios: {
        scenarios,
        currentScenario,
        scenarioItems,
        lists: {
          officialScenarioItems,
          otherScenarioItems,
          archivedScenarioItems
        }
      }
    })
  }

  return (
    <Page className="Scenarios">
      {/* <PageRight>{!isLoading && <ScenarioConsole project={currentProject} />}</PageRight> */}

      <PageCenter numSections={PageNumSections.TWO_SECTIONS}>
        <ScenarioActionsBar />
        <AccessControl
          userPermissions={[userRightTypes.SCENARIO_READ]}
          renderNoAccess={() => <AccessControlNoRights />}
        >
          <div className="listContainer">
            <ScenarioOfficialList pid={pid} official={officialScenarioItems} isLoading={isLoading} />
            <ScenarioOtherList pid={pid} other={otherScenarioItems} isLoading={isLoading} />
            <ScenarioArchivedList pid={pid} archived={archivedScenarioItems} isLoading={isLoading} />
          </div>
        </AccessControl>
      </PageCenter>

      <PageLeft>
        <AccessControl userPermissions={[userRightTypes.SCENARIO_READ]} renderNoAccess={() => <></>}>
          {!isLoading && (
            <Grid item={true} xs={true} className="projectAttributesContainer">
              <ProjectCard currentProject={currentProject} />
              <Divider />
              <ProjectAttributesTabs
                currentProject={currentProject}
                currentScenario={currentScenario}
                loadData={loadData}
                locations={locationItems}
                weather_data={weatherItems}
                // resources={resourceItems}
                // variables={variableItems}
                // products={productItems}
                // parameters={parameterItems}
              />
            </Grid>
          )}
        </AccessControl>
      </PageLeft>
    </Page>
  )
}
